import { Text, DatePicker, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

export declare namespace DateTypes {
  type SelectionProps = Date | null;

  type ValueChange = (date: SelectionProps, fieldName: string, filterIndex: number) => void;

  interface Props {
    type: 'date';
    fieldName: string;
    title: string;
    placeholder: string;
    filterIndex: number;
    onValueChange: ValueChange;
    selection?: SelectionProps;
    zIndex: number;
  }
}

export const hasDateSelection = (date: Date | null) => !!date;

export const Date: React.FC<DateTypes.Props> = ({
  title,
  fieldName,
  filterIndex,
  onValueChange,
  selection,
  placeholder,
  zIndex,
}) => {
  return (
    <VStack w="full" space={Spacing['inline.nano']} zIndex={2 + zIndex}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} lineHeight="distant">
        {title}
      </Text>
      <HStack w="full">
        <DatePicker
          date={selection || undefined}
          onClear={() => onValueChange(null, fieldName, filterIndex)}
          onSelectDate={(date) => onValueChange(date, fieldName, filterIndex)}
          calendarPosition="left"
          placeholder={placeholder}
        />
      </HStack>
    </VStack>
  );
};
